import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    display: "flex",
    width: "100%",
    heifht: "100%",
    gap: 1,
    flexWrap: "wrap",
    minWidth: 0,
  },
  titleAndLinkPage: {
    flexGrow: 1,
    fontWeight: 400,
    fontSize: "1.25rem",
    // mt: 1,
    // mb: 2,
  },
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    gap: 2,
    minWidth: 0,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: 1,
  },
  tabs: {
    height: "100%",
    "& button": {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.secondary,
      padding: "0px !important",
      textTransform: "none",
      transition: "background 0.2s",
      borderRadius: "0 !important",
    },
    "& .MuiTabs-flexContainer": {
      height: "36px",
    },
    "& button.Mui-selected": {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      color: theme.palette.primary.main,
      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.08)}`,
      borderRadius: "6px 6px 0 0",
      zIndex: 1,
      position: "relative",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  boxNoRowsOverlay: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  iconUserNotFound: {
    width: "140px",
    height: "140px",
    fill: theme.palette.text.disabled,
  },
  dataGrid: {
    width: "100%",
    minHeight: 500,
    fontSize: 12,
    borderRadius: 0,
    border: 0,
    backgroundColor: "transparent",
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    ".MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      borderColor: theme.palette.stroke,
    },
    "& .MuiDataGrid-scrollbar--vertical": {
      display: "none",
    },
    "& .MuiDataGrid-filler": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--borderTop": {
      display: "none",
    },
    "& .MuiDataGrid-scrollbarFiller--header": {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.stroke}`,
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      color: "text.primary", // Altera a cor do titulo do cabeçalho
    },
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "transparent", // Altera cor do rodapé
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      height: "45px",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: theme.palette.background.paper, // Altera cor do cabeçalho
      border: 0,
      borderTop: `1px solid ${theme.palette.stroke}`,
      width: "100%",
    },
    "& .MuiDataGrid-topContainer": {
      border: 0,
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiDataGrid-row--borderBottom": {
      border: 0,
    },
    "& .MuiDataGrid-columnHeaders": {
      border: 0,
      height: "55px",
      backgroundColor: theme.palette.background.paper,
    },

    "& .even-row": { backgroundColor: theme.palette.table },
    "& .odd-row": { backgroundColor: theme.palette.background.paper },
  },
  boxHeader: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    height: "fit-content",
    justifyContent: "space-between",
    alignItems: { xs: "start", md: "center" },
    gap: { xs: 2, md: 0 },
  },
  button: {
    height: "40px",
    transition: "opacity 0.5s, background-color 0.5s, filter 0.5s, color 0.5s",
    opacity: 1,
  },
});
